module.exports = __webpack_public_path__ + "img/data.49305e46.png";